import type { LegendItemClickEventObject, Series } from "highcharts";

type SeriesLegendCustomOptions = {
  onLegendItemClick?: (series: Series, event: LegendItemClickEventObject) => void;
};

export const handleLegendItemClick = (event: LegendItemClickEventObject) => {
  const legendItem = event.legendItem;
  if (!("options" in legendItem)) {
    return;
  }

  const series = legendItem as Series;
  const custom = series.options.custom as SeriesLegendCustomOptions | undefined;
  custom?.onLegendItemClick?.(series, event);

  if (series.type === "plotwindbarb" || series.type === "weathersymbol") {
    setChartOffsetDependingOnSerieIcon(event);
  }
};

export const setChartOffsetDependingOnSerieIcon = (
  e: Pick<LegendItemClickEventObject, "browserEvent" | "preventDefault">,
) => {
  e.browserEvent?.stopImmediatePropagation();
  e.browserEvent?.preventDefault();
  e.preventDefault?.();
  // This is currently not working, hide and show icons series
  // (wind barbs and weather icons) are only possible over layer stack
  // code is kept to fix it later => i discover more problems with the icon placement when trying to make it work

  // const IconSerieId = e.target.options.id;
  // // this is previous state, so we assume, that current state is !visible
  // const show = !e.target.options.visible;

  // if (IconSerieId) {
  // const series = e.target.chart.userOptions?.series ?? [];
  // for (const serie of series) {
  //   // change visible for id
  //   if (IconSerieId === serie.id) {
  //     serie.visible = show;
  //   }
  // }
  // e.target.chart.options?.customDispatch(e.target.chart.options?.customSetSeries(leftVisibleIcons));
  // }
};
